var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { BaseButtonView } from './BaseButtonView';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { Animated } from 'react-native';
import { getColorScheme } from '../../Hooks/UseColorScheme';
import { stringToRgb } from '../../../Helpers/Hex/Hex';
import { useColorSchemeContext } from '../../Contexts/ThemeContext';
const style = (props) => {
    return {
        container: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            paddingVertical: 0,
            paddingHorizontal: 0,
        },
        text: {
            color: props.light
                ? stringToRgb(getColorScheme().value.colors.text)
                : 'rgba(99, 120, 143, 1)',
            textDecorationLine: 'underline',
            textDecorationColor: props.light
                ? stringToRgb(getColorScheme().value.colors.text)
                : 'rgba(99, 120, 143, 1)',
            textDecorationStyle: 'solid',
            fontSize: 14,
            textTransform: undefined
        },
        hover: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        pressed: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        pressedText: {
            color: props.light
                ? stringToRgb(getColorScheme().value.colors.text)
                : 'rgba(99, 120, 143, 0.8)',
        },
        inactive: {
            color: 'rgba(184, 189, 199, 1)'
        },
        disabled: {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
        }
    };
};
export const UnderlineButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.underlineButton,
    style(theme, mediaQuery, window, props) {
        return style(props);
    }
})((_a) => {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var { style: default_style } = _a, props = __rest(_a, ["style"]);
    const color_scheme_context = useColorSchemeContext();
    const animation = useRef(new Animated.Value(0)).current;
    const handlePress = useCallback(() => {
        var _a;
        (_a = props.onPress) === null || _a === void 0 ? void 0 : _a.call(props);
        Animated.timing(animation, {
            useNativeDriver: false,
            toValue: 1,
            duration: 100
        }).start(() => {
            Animated.timing(animation, {
                useNativeDriver: false,
                toValue: 0,
                duration: 100
            }).start();
        });
    }, [props.onPress]);
    let current_style = default_style;
    if ((color_scheme_context.scheme === 'dark' || getColorScheme().value.scheme === 'dark') && props.light === undefined) {
        current_style = style(Object.assign(Object.assign({}, props), { light: true }));
    }
    const textColor = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [
            ((_b = current_style === null || current_style === void 0 ? void 0 : current_style.text) === null || _b === void 0 ? void 0 : _b.color) || 'rgba(99, 120, 143, 1)',
            ((_c = current_style === null || current_style === void 0 ? void 0 : current_style.pressedText) === null || _c === void 0 ? void 0 : _c.color) || 'rgba(99, 120, 143, 0.8)',
        ]
    });
    const fontWeight = props.bold
        ? '600'
        : '400';
    return _jsx(BaseButtonView, Object.assign({}, props, { style: undefined, wrapperStyle: [
            {
                minHeight: 18,
                flex: undefined,
                width: undefined
            },
            props.wrapperStyle
        ], color: props.color || ((_d = current_style === null || current_style === void 0 ? void 0 : current_style.text) === null || _d === void 0 ? void 0 : _d.color), onPress: handlePress, containerStyle: Object.assign(Object.assign(Object.assign({}, current_style === null || current_style === void 0 ? void 0 : current_style.container), { backgroundColor: undefined, minHeight: undefined, flex: undefined, width: undefined }), props.containerStyle), textStyle: [current_style === null || current_style === void 0 ? void 0 : current_style.text, props.textStyle, { fontWeight, color: textColor }, !!props.color && { color: props.color, textDecorationColor: props.color }], disabled: props.disabled || props.inactive, defaultBackground: (_e = current_style === null || current_style === void 0 ? void 0 : current_style.container) === null || _e === void 0 ? void 0 : _e.backgroundColor, hoverBackground: (_f = current_style === null || current_style === void 0 ? void 0 : current_style.hover) === null || _f === void 0 ? void 0 : _f.backgroundColor, pressBackground: (_g = current_style === null || current_style === void 0 ? void 0 : current_style.pressed) === null || _g === void 0 ? void 0 : _g.backgroundColor, inactiveBackground: (_h = current_style === null || current_style === void 0 ? void 0 : current_style.inactive) === null || _h === void 0 ? void 0 : _h.backgroundColor, disableBackground: (_j = current_style === null || current_style === void 0 ? void 0 : current_style.disabled) === null || _j === void 0 ? void 0 : _j.backgroundColor }));
});
